import UtilsUrl from "../../utils/UtilsUrl";
import api from "../api";




class CarteCadeauService{

  getAllCarteCadeau(idUser,idWarehouse,isActive) {
    return api.get(
      UtilsUrl.CarteCadeauURL() +
        "/getAllCarteCadeau/"+idUser+"/"+idWarehouse+"/"+isActive
    );
  }

  addCarteCadeau(carteCadeauAddModel) {
    return api.post(
      UtilsUrl.CarteCadeauURL() +
        "/addCarteCadeau",carteCadeauAddModel
    );
  }
  getCarteCadeauDeatils(idUser, idCarteCadeau) {
    return api.get(
      UtilsUrl.CarteCadeauURL() +
      `/getCarteCadeauDetails/${idUser}/${idCarteCadeau}`
    );
  }
  activeOrDesactiveCarteCadeau(idUser, idCarteCadeau, activeOrDesactive) {
    return api.put(
      UtilsUrl.CarteCadeauURL() +
      `/activeOrDesactiveCarteCadeau/${idUser}/${idCarteCadeau}/${activeOrDesactive}`
    );
  }
  deleteCarteCadeauById(idUser, idCarteCadeau, activeOrDesactive) {
    return api.put(
      UtilsUrl.CarteCadeauURL() +
      `/deleteCarteCadeauById/${idUser}/${idCarteCadeau}/${activeOrDesactive}`
    ); 
  }


}
export default new CarteCadeauService();